import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Chat from '../../containers/Chat/chat';
import PreChat from '../../containers/PreChat/preChat'
import PreChatDafaplus from '../../containers/PreChat/PreChatDafaplus'
import { RootState, useAppDispatch } from '../../redux/store';
import { setPage } from '../../redux/slices/pageSlice';
import { restoreSession } from '../../redux/slices/userSlice';
import { sessionDataHandler, SESSION_STORAGE_KEY } from '../../sessionDataHandler';

interface FrameProps {
    brand?: string;
}

export const Frame: React.FC<FrameProps> = ({ brand }) => {

    const dispatch = useAppDispatch();
    const currentPage = useSelector((state: RootState) => state.page.currentPage);
    const hasActiveUser = useSelector((state: RootState) => !!(state.user as any)?.user?.token);
    const isDafaplus = brand?.toLowerCase() === 'dafaplus';

    // Resume an existing DafaPlus chat session (e.g. same link opened in another tab)
    // before the pre-chat form ever gets a chance to render.
    const [resumedSession] = useState(() => (isDafaplus ? sessionDataHandler.tryResumeExistingSession() : null));

    useEffect(() => {
        if (resumedSession && !hasActiveUser) {
            dispatch(restoreSession(resumedSession));
            dispatch(setPage('chat'));
        }
    }, [resumedSession, hasActiveUser, dispatch]);

    // Another tab finished the pre-chat flow and stored a session while this tab was
    // already open (e.g. still sitting on the pre-chat form) - jump into chat live.
    useEffect(() => {
        if (!isDafaplus) {
            return;
        }

        const handleStorage = (event: StorageEvent) => {
            if (event.key !== SESSION_STORAGE_KEY || !event.newValue) {
                return;
            }

            const resumed = sessionDataHandler.tryResumeExistingSession();
            if (resumed) {
                dispatch(restoreSession(resumed));
                dispatch(setPage('chat'));
            }
        };

        window.addEventListener('storage', handleStorage);
        return () => window.removeEventListener('storage', handleStorage);
    }, [isDafaplus, dispatch]);

    const effectivePage = resumedSession ? 'chat' : currentPage;

    return (
        <>
            {effectivePage === 'chat' && <Chat />}
            {effectivePage === 'pre-chat' && isDafaplus && <PreChatDafaplus />}
            {effectivePage === 'pre-chat' && !isDafaplus && <PreChat />}
        </>
    );
};

export default Frame;
